import { createRouter, createWebHistory } from 'vue-router' 
import { useSessionStore } from '@/stores/session'

import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'

import SentView from '@/views/invitations/SentView.vue'
import InvitationDetailView from '@/views/invitations/InvitationDetailView.vue'
import HiredVendorsView from '@/views/invitations/HiredVendorsView.vue'
import ReceivedView from '@/views/invitations/ReceivedView.vue'
import ReceivedDetailView from '@/views/invitations/ReceivedDetailView.vue' 
import ConnectionsListView from '@/views/invitations/ConnectionsListView.vue'
import AddInvitationView from '@/views/invitations/AddInvitationView.vue'
import CoHostView from '@/views/invitations/CoHostView.vue'
import EditInvitationView from '@/views/invitations/EditInvitationView.vue' 
import AddGuestsView from '@/views/invitations/AddGuestsView.vue'
import AddVendorsView from '@/views/invitations/AddVendorsView.vue'
import AlbumsView from '@/views/albums/AlbumsView.vue'
import AlbumsDetail from '@/views/albums/AlbumsDetail.vue'
import UploadPermissionsView from '@/views/albums/UploadPermissionsView.vue'
import ViewPermissionsView from '@/views/albums/ViewPermissionsView.vue'
import EventSettingsView from '@/views/invitations/EventSettingsView.vue'

import VendorsView from '@/views/vendors/VendorsView.vue' 
import VendorDetailView from '@/views/vendors/VendorDetailView.vue'

import ContactsView from '@/views/settings/ContactsView.vue'
import EnquiriesView from '@/views/settings/EnquiriesView.vue' 
import ChangePasswordView from '@/views/settings/ChangePasswordView.vue'
import SettingsView from '@/views/settings/SettingsView.vue'
import UpdateProfileView from '@/views/settings/UpdateProfileView.vue' 
import ProfileView from '@/views/invitations/Profile.vue'

import EnquiriesList from '@/views/invitations/EnquiriesList.vue'
import AddEnquiry from '@/views/invitations/AddEnquiry.vue' 
import Feedbacks from '@/views/invitations/Feedbacks.vue' 
import PublicLink from '@/views/PublicLink.vue'

const routes = [ 
    {path: '/',name: 'explore',component: SentView, meta: { requiresAuth: true }}, 
    {path: '/login',name: 'login',component: LoginView}, 
    {path: '/register',name: 'register',component: RegisterView}, 
    {path: '/forgot-password', name: 'forgot-password', component: ForgotPassword},

    {path: '/host',name: 'host',component: SentView, meta: { requiresAuth: true }}, 
    {path: '/detail/:slug',name: 'invitation-detail',component: InvitationDetailView, meta: { requiresAuth: true }}, 
    {path: '/detail/vendors/:slug',name: 'hired-vendors',component: HiredVendorsView, meta: { requiresAuth: true }}, 
    {path: '/detail/vendors/add-vendor/:slug',name: 'list-nearby-vendors',component: AddVendorsView, meta: { requiresAuth: true }}, 
    {path: '/guest/:slug',name: 'add-guest-list',component: AddGuestsView, meta: { requiresAuth: true }}, 
    {path: '/feedbacks/:slug',name: 'feedbacks-list',component: Feedbacks, meta: { requiresAuth: true }}, 

    {path: '/detail/enquiry-list/:slug',name: 'event-enquiries',component: EnquiriesList, meta: { requiresAuth: true }}, 
    {path: '/add-enquiry/:slug',name: 'add-enquiry',component: AddEnquiry, meta: { requiresAuth: true }}, 
    {path: '/send-enquiry/:slug',name: 'send-enquiry',component: AddEnquiry, meta: { requiresAuth: true }}, 

    {path: '/received',name: 'received',component: ReceivedView, meta: { requiresAuth: true }}, 
    {path: '/received/:slug',name: 'received-detail',component: ReceivedDetailView, meta: { requiresAuth: true }}, 
    {path: '/received/:slug/connections',name: 'received-connections',component: ConnectionsListView, meta: { requiresAuth: true }},
    {path: '/profile/:slug',name: 'profile-detail',component: ProfileView, meta: { requiresAuth: true }}, 

    {path: '/create-invitation',name: 'create-invitation',component: AddInvitationView, meta: { requiresAuth: true }}, 
    {path: '/create-event',name: 'create-event',component: AddInvitationView, meta: { requiresAuth: true }}, 
    {path: '/edit-invitation/:slug',name: 'edit-invitation',component: EditInvitationView, meta: { requiresAuth: true }}, 
    {path: '/cohost/:slug',name: 'cohost-info',component: CoHostView, meta: { requiresAuth: true }},  

    {path: '/vendors',name: 'vendors',component: VendorsView, meta: { requiresAuth: true }}, 
    {path: '/:slug',name: 'vendor-detail',component: VendorDetailView, meta: { requiresAuth: true }}, 

    { path: '/i/:mainSlug', name: 'public-invite-main', component: PublicLink },
    { path: '/i/:mainSlug/:subSlug', name: 'public-invite-detail', component: PublicLink },


    {path: '/albums',name: 'albums',component: AlbumsView, meta: { requiresAuth: true }},
    {path: '/album/:slug',name: 'album-detail',component: AlbumsDetail, meta: { requiresAuth: true }}, 
    {path: '/album/upload-permission/:slug',name: 'upload-permission',component: UploadPermissionsView, meta: { requiresAuth: true }}, 
    {path: '/album/view-permission/:slug',name: 'view-permission',component: ViewPermissionsView, meta: { requiresAuth: true }}, 
    {path: '/event-settings/:slug', name: 'event-settings', component: EventSettingsView, meta: { requiresAuth: true }},

    {path: '/my-contacts',name: 'contacts-list',component: ContactsView, meta: { requiresAuth: true }},
    {path: '/enquiries-list',name: 'enquiries-list',component: EnquiriesView, meta: { requiresAuth: true }},
    {path: '/settings',name: 'settings',component: SettingsView, meta: { requiresAuth: true }},
    {path: '/change-password',name: 'change-password',component: ChangePasswordView, meta: { requiresAuth: true }},
    {path: '/update-profile',name: 'update-profile',component: UpdateProfileView, meta: { requiresAuth: true }},

    {path: '/:pathMatch(.*)*',  name: 'NotFound', component: () => import('@/views/NotFound.vue')},
    {path: '/:catchAll(.*)', redirect: '/login' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

 
// Guard
router.beforeEach(async (to, from, next) => {
  const sessionStore = useSessionStore()

  // Load user data (e.g., from localStorage or API)
  await sessionStore.loadUser()

  const isLoggedIn = sessionStore.isLoggedIn
  const authRequired = to.meta.requiresAuth
  const guestOnly = ['/login', '/register'].includes(to.path)

  // 🚫 Protected route, but user not logged in → redirect to login
  if (authRequired && !isLoggedIn) {
    return next('/login')
  }

  // 🔐 Trying to access login or register while logged in → redirect to /host
  if (guestOnly && isLoggedIn) {
    return next('/host')
  }

  // ✅ All good → proceed
  next()
})

export default router
